import * as React from "react";
import { useRadioGroup } from "@react-aria/radio";
import { useRadioGroupState } from "@react-stately/radio";
import { css } from "@nju/css";
import { RadioGroupProvider } from "./context";

export interface RadioGroupProps {
  name: string;
  value?: string;
  defaultValue?: string;
  onValueChange?: (value: string) => void;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  label?: React.ReactNode;
  id?: string;
  "aria-label"?: string;
  state?: "error";
}

export const RadioGroup = React.memo<React.PropsWithChildren<RadioGroupProps>>(
  function RadioGroup(props) {
    const { onValueChange, ...rest } = props;
    const state = useRadioGroupState({ onChange: onValueChange, ...rest });
    const { radioGroupProps, labelProps } = useRadioGroup(
      { onChange: onValueChange, ...rest },
      state,
    );

    return (
      <div {...radioGroupProps}>
        {props.label ? (
          <span {...labelProps} className={styles.label()}>
            {props.label}
          </span>
        ) : undefined}
        <RadioGroupProvider
          isRequired={props.isRequired}
          validationState={props.state}
          {...state}
        >
          {props.children}
        </RadioGroupProvider>
      </div>
    );
  },
);
const styles = {
  label: css({ marginBottom: 20, display: "inline-block" }),
};
